export default "__VITE_ASSET__CmEsg1Yr__"